module.exports = __webpack_public_path__ + "static/fire_sensor-cbd02f8563486dc33a8852466668f5a7.jpg";